import ShowFavorites from "./ShowFavorites";

export default ShowFavorites;
